import styled from 'styled-components';
import { Modal, ModalBody, Row } from 'reactstrap';

import { theme } from '../../styles';
import { Button } from '../../components/button/button';

export const StyledModal = styled(Modal)`
  font-weight: 500;
  width: 440px;
  color: #1a2240;
  label {
    color: #464f60;
  }
  .modal-content {
    border-radius: 12px;
  }
`;

export const StyledAddAttribute = styled(Button)`
  width: 24px;
  height: 24px;
`;

export const StyledModalBody = styled(ModalBody)`
  padding: 0.5rem 1rem 1rem 1rem;
  background-color: ${theme.colors.grey[0]};
`;

export const StyledDeleteButton = styled(Button)`
  width: 32px;
`;

export const StyledFileInput = styled.label`
  margin-bottom: 0;
  cursor: pointer;
  padding: 0;
  color: ${theme.colors.primary[600]} !important;
`;

export const StyledRow = styled(Row)`
  background-color: ${theme.colors.grey[50]};
  color: ${theme.colors.grey[700]};
  font-size: ${theme.fontSize.small};
  font-weight: 500;
  border-radius: 4px;
`;

export const StyledFile = styled.input`
  all: unset;
  flex: 1;
  padding: 2px;
  background: url(${({ icon }) => icon}) no-repeat scroll 8px 2px;
  padding-left: 28px;
`;
